import { defaultLineColor } from "@/modules/policies/policies.const";
import { GroupedStreetData, ICurbZoneSummary, StreetCount } from "./onstreet.type";
import { findObject, sortDesc } from "@/helper/array";
import { fromGraphQLColor } from "@/helper/utils";

import { ColorInput } from "@/types";
import { CurbZone } from "types/curb-zone.type";
import { OptionType } from "@/components/form-control/dropdown-select";

export type PolicyOption = OptionType & Pick<ColorInput, "lineColor">;
// A voir
export const curbZoneCounter = (curbZones: CurbZone[]) => {
  let resultsParking: ICurbZoneSummary = {
    totalArea: 0,
    totalPlace: 0,
  };

  curbZones.forEach((item) => {
    resultsParking = {
      totalPlace: resultsParking.totalPlace + (item.calculatedSpaces || 0),
      totalArea: resultsParking.totalArea + (item.calculatedArea || 0),
    };
  });

  return resultsParking;
};

export function countPlacesByStreet(zones: CurbZone[]): StreetCount[] {
  const streetMap = new Map<string, StreetCount>();

  zones.forEach((zone) => {
    if (zone.streetName) {
      const currentData = streetMap.get(zone.streetName) ?? { name: zone.streetName, count: 0, zones: [] };
      const currentCount = zone.calculatedSpaces ?? 0;
      streetMap.set(zone.streetName, {
        ...currentData,
        count: currentData.count + currentCount,
        zones: [...currentData.zones, zone],
      });
    }
  });

  const result = Array.from(streetMap.values());
  return sortDesc(result, "count");
}

export const groupCurbZonesData = (curbZones: CurbZone[]) => {
  const listPolicy: PolicyOption[] = [];
  const groupedPolicyData = new Map<string, CurbZone[]>();
  const groupedStreetData: GroupedStreetData = {};

  curbZones.forEach((item) => {
    // Logic for groupPolicyAndCalculateSpaces
    item.curbPolicies.forEach((policy) => {
      const fPolicy = findObject(listPolicy, "value", policy.curbPolicyId ?? "");
      if (fPolicy === -1) {
        listPolicy.push({
          value: policy.curbPolicyId ?? "",
          label: policy.name,
          lineColor: fromGraphQLColor(policy.color?.lineColor, defaultLineColor),
        });
      }
      const currentPolicyData = groupedPolicyData.get(policy.curbPolicyId ?? "") ?? [];
      groupedPolicyData.set(policy.curbPolicyId ?? "", [...currentPolicyData, item]);
    });

    // Logic for groupStreetAndCalculateSpaces
    const streetName = String(item.streetName?.trim());
    const curbPolicyName = item.curbPolicies[0]?.name;

    if (!groupedStreetData[streetName]) {
      groupedStreetData[streetName] = [];
    }

    const findCurbPolicy = groupedStreetData[streetName].find((policy) => policy.name === curbPolicyName);

    if (findCurbPolicy) {
      findCurbPolicy.calculatedSpaces += item.calculatedSpaces;
      findCurbPolicy.calculatedArea += item.calculatedArea;
    } else {
      groupedStreetData[streetName].push({
        name: curbPolicyName,
        calculatedSpaces: item.calculatedSpaces,
        calculatedArea: item.calculatedArea,
      });
    }
  });

  return {
    // Result from groupPolicyAndCalculateSpaces
    policies: listPolicy,
    groupedPolicyData,
    // Result from groupStreetAndCalculateSpaces
    streetData: groupedStreetData,
  };
};
